import Vue from "vue";
import store from "./store";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "./filter";
import Mint from "mint-ui";
import "element-ui/lib/theme-chalk/index.css";
import "mint-ui/lib/style.css";
import "./base.css";
import "nprogress/nprogress.css";
import "./index.css";
import htmlToPdf from "./utils/htmpToPDF";
// 使用Vue.use()方法就会调用工具方法中的install方法

console.log(process.env.NODE_ENV, "NODE_ENV", process.env.VUE_APP_PROJECT_URL);
Vue.use(htmlToPdf);
Vue.config.productionTip = false;
Vue.use(Mint);
Vue.use(ElementUI);
document.addEventListener("DOMContentLoaded", function() {
  document.getElementById("loading").style.display = "none";
});
new Vue({
  router,
  store,

  render: h => h(App)
}).$mount("#app");
